<template>
  <div>
    <div class="admin-toggle_container input-forms">
      <modal
        ref="transferModal"
        template="loading"
        title="Aguarde"
        ref-name="transferModal"
      >
        <p>Salvando Toggles.</p>
      </modal>

      <subheader title="Administração de Funcionalidades" />
      <div class="admin-toggle__patient width-responsiveness">
        <h2
          id="adminFormTitle"
          class="admin-toggle__patient__title title-main"
        >
          Gestão de Features por Laboratório
        </h2>

        <card-form :collapsed="!isToggleCollapsed">
          <div
            slot="expanded"
            class="form-container"
          >
            <span class="tab-label">
              Caso queira inserir mais de um ID, basta separá-los por vírgula.
            </span>
            <span class="required-fields-label">* Preenchimento obrigatório</span>
            <md-layout
              :md-gutter="24"
              md-flex="100"
            >
              <md-layout
                md-flex="40"
                md-flex-medium="40"
                class="inputidlab"
              >
                <md-input-container
                  id="adminIDLab"
                  :class="{ 'md-input-invalid': errors.has('idlab') }"
                >
                  <label>ID(s) do(s) Laboratório(s) *</label>
                  <md-input
                    id="txtIdLab"
                    v-model="laboratoryID"
                    v-validate="'required'"
                    data-vv-validate-on="none"
                    name="idlab"
                    maxlength="250"
                    type="text"
                    title=""
                    placeholder="ID(s) do(s) Laboratório(s) *"
                    @keyup.enter.native="validateBeforeSubmit()"
                  />
                  <span class="md-error">Obrigatório</span>
                </md-input-container>
              </md-layout>

              <md-layout
                md-flex="20"
                md-flex-medium="20"
              >
                <md-input-container
                  id="featureName"
                  name="feature"
                  :class="{
                    'md-input-placeholder md-advanced-select': true,
                    'md-has-value': featureModel,
                    'md-input-invalid': errors.has('feature'),
                  }"
                >
                  <label>Feature *</label>
                  <advanced-select
                    id="cboFeature"
                    v-model="featureModel"
                    v-validate="'required'"
                    :options="features"
                    placeholder=""
                    name="feature"
                    data-vv-validate-on="none"
                    title=""
                  />
                  <span class="md-error">Obrigatório</span>
                </md-input-container>
              </md-layout>

              <md-layout
                md-flex="20"
                md-flex-medium="20"
              >
                <md-input-container
                  id="toggleValueOption"
                  name="toggleValue"
                  :class="{
                    'md-input-placeholder md-advanced-select': true,
                    'md-has-value': optionModel,
                    'md-input-invalid': errors.has('toggleValue'),
                  }"
                >
                  <label>Valor *</label>
                  <advanced-select
                    id="cboToggleValueOption"
                    v-model="optionModel"
                    v-validate="'required'"
                    :options="toggleValueOptions"
                    placeholder=""
                    name="toggleValue"
                    data-vv-validate-on="none"
                    title=""
                    @keyup.enter.native="validateBeforeSubmit(false)"
                  />
                  <span class="md-error">Obrigatório</span>
                </md-input-container>
              </md-layout>

              <md-layout md-flex="25">
                <md-button
                  id="btnAdminSubmitFeature"
                  class="btn btn-primary admin-toggle__patient__submit-button submit-button"
                  @click="validateBeforeSubmit"
                >
                  SALVAR
                </md-button>
              </md-layout>
            </md-layout>
          </div>
        </card-form>
      </div>
    </div>
  </div>
</template>

<script>
import SubHeader from '@/components/common/SubHeader'
import AdvancedSelect from '@/components/common/AdvancedSelect'
import strings from '@/strings'
import { mapActions } from 'vuex'
import CardForm from '@/components/common/CardForm'
import { mask } from 'vue-the-mask'
import notify from '@/api/notification'

export default {
  name: 'Admin',
  components: {
    subheader: SubHeader,
    'advanced-select': AdvancedSelect,
    'card-form': CardForm,
  },
  directives: {
    mask: mask,
  },
  data: () => {
    return {
      laboratoryID: '',
      featureModel: '',
      optionModel: '',
      features: strings.adminFeature,
      toggleValueOptions: strings.adminFeatureOptions,
      isToggleCollapsed: false,
      loadingData: false,
    }
  },
  methods: {
    ...mapActions(['setToggle']),
    closeTransferDialog() {
      if (this.$refs.transferModal) {
        this.$refs.transferModal.close()
        this.loadingData = false
      }
    },
    openTransferDialog() {
      this.$refs.transferModal.open()
      this.loadingData = true
    },
    validateBeforeSubmit(evt) {
      // Abort if user pressed enter + shift
      if (evt && evt.keyCode === 13 && evt.shiftKey) {
        return
      }
      this.$validator.validateAll().then(result => {
        if (this.errors.items.length === 0) {
          this.openTransferDialog()
          let laboratoryIds = this.laboratoryID.split(',')
          let name = this.featureModel.value
          let enabled = this.optionModel.value
          this.setToggle({ laboratoryIds, name, enabled })
            .then(response => {
              if (response === undefined) {
                this.closeTransferDialog()
              } else if (response) {
                this.closeTransferDialog()
              }
            })
            .catch(() => {
              let erroMsg = 'Erro  ao salvar Toggle. Por favor tente novamente.'
              this.closeTransferDialog()
              notify({
                title: 'AVISO:',
                message: erroMsg,
              })
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '../../../static/stylesheets/mixins';

//Admin Toggle Page Styles
.admin-toggle_container {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 58px);

  .card-form__container {
    transition: min-height 600ms, opacity 600ms;
    opacity: 1;
    border-radius: 6px;

    .form-container {
      animation-name: fadein;
      animation-duration: 700ms;
      display: flex;

      .required-fields-label {
        position: absolute;
        right: 5px;
        top: -30px;
        font-size: 12px;
        color: #a80009;
      }

      .tab-label {
        position: absolute;
        right: 180px;
        bottom: 60px;
        font-size: 12px;
        color: #000;
        border-bottom-color: transparent;
        strong {
          font-weight: 700;
        }
      }

      .md-layout {
        .md-input-container {
          margin: 0 0 17px;
        }
      }

      .md-input-container,
      .md-input-container.md-input-focused {
        .md-icon {
          color: #c2c2c2;
        }
      }
    }
  }

  .admin-toggle__patient {
    margin-top: 150px;

    .form-container {
      .md-gutter-24:not(.md-column) {
        margin-right: 0;
        margin-left: 0;
      }
    }
  }

  .admin-toggle {
    &__exam {
      height: 400px;

      &__save-button {
        width: 182px;

        &__icon-save {
          margin: 0 7px 0 0;
          width: 16px;
          height: 15px;
          min-height: 15px;
          min-width: 16px;
        }
      }
      &__save-reload-button {
        width: 263px;
        margin-right: 20px;

        &__icon-reload {
          margin: 0 7px 0 0;
          width: 16px;
          height: 15px;
          min-height: 15px;
          min-width: 16px;
        }
      }
    }

    &__patient__title {
      margin: 48px 0 30px;
    }

    &__exam__title {
      margin: 54px 0 31px;
    }

    &__footer {
      margin: 36px 0;
      .endButton {
        flex-wrap: nowrap;
      }
    }
  }

  .advanced-select {
    &__container {
      .multiselect {
        &__single {
          width: 100%;
          color: #303030;
          font-size: 16px;
          @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
            margin: 1px 0 0;
          }
        }
      }
    }
  }
}

@keyframes fadeout {
  0% {
    opacity: 1;
  }
  99% {
    opacity: 0;
  }
  100% {
    display: none;
  }
}
@keyframes fadein {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@media all and (max-width: 1024px) {
  .admin-toggle__patient .card-form__container .submit-button {
    right: 19px;
  }
}

.IE-11 {
  .inputidlab {
    min-width: 30%;
    max-width: 35%;
  }
}
</style>
